export default __webpack_public_path__ + "static/5905v5907_2_thumb-5e8914e02da7630076b2ca1c3aa795cc.png";